import React from 'react'

export const LocatorSection = ({slice}) => {
  return <section className='prod-locator__lookup-map'>
      <div id='locator-container'></div>
    </section>
}